import "./App.css";
import Routes from "./utils/routes";
import "react-datepicker/dist/react-datepicker.css";
import GeoCode from "react-geocode";
GeoCode.setApiKey(process.env.REACT_APP_GEOCODE_API_KEY!);
const App = () => <Routes />;
export default App;
